import PropTypes from "prop-types";
//Styles
import styled from "styled-components";
//theme
import theme from "../../../styles/theme.semantic";

const Line = styled.div`
  transition: width 0.2s;
  height: ${props => props.height || theme.components.line.height + "px"};
  background-color: ${props => props.color || theme.components.line.color};
  margin-top: ${props =>
    props.marginTop || theme.components.line.marginTop + "px"};
  margin-bottom: ${props => props.marginBottom};
  width: ${props =>
    props.isHover
      ? props.theme.components.line.width +
        props.theme.components.line.widthDifference
      : props.theme.components.line.width -
        props.theme.components.line.widthDifference}px;
`;

Line.defaultProps = {
  width: theme.components.line.width + "px"
};

Line.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
  marginTop: PropTypes.string,
  marginBottom: PropTypes.string,
  isHover: PropTypes.bool
};

export default Line;
